import { createBundle } from 'widget/Common';

import MapView from 'bundle-loader?lazy&name=DakaDownLoadView!pages/Map/index';

const RouterConfig = [
  {
    path: '/map/storeSetup',
    title: '地图演示',
    component: () => {
      return createBundle(MapView);
    }
  }
];
export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/Map/RouterConfig.js